import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.357 16.786a3.5 3.5 0 0 0 4.862 4.862.875.875 0 0 1 1.348.543 8.75 8.75 0 1 1-6.753-6.753.875.875 0 0 1 .543 1.348ZM17.005 24a7 7 0 0 1 7.296-6.994 5.25 5.25 0 0 0 6.697 6.697A7 7 0 1 1 17.004 24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.005 10c-7.889 0-14.49 3.442-19.737 10.273a6.125 6.125 0 0 0-.004 7.458C9.498 34.559 16.101 38 24.004 38c7.906 0 14.506-3.442 19.735-10.272a6.125 6.125 0 0 0-.004-7.452C38.493 13.443 31.894 10 24.005 10ZM5.653 26.666a4.375 4.375 0 0 1 .003-5.327c4.925-6.41 11.02-9.589 18.349-9.589 7.33 0 13.422 3.18 18.341 9.591a4.375 4.375 0 0 1 .003 5.323c-4.906 6.408-10.999 9.586-18.344 9.586-7.345 0-13.44-3.177-18.352-9.584Z",
    fill: "currentColor"
  }));
};

var SvgVisibleOn = styled(SvgComponent).withConfig({
  displayName: "VisibleOn__SvgVisibleOn",
  componentId: "sc-7c0e3m-0"
})(["", " ", ""], size, color);
export default SvgVisibleOn;